import { Routes } from '@angular/router';
import { SharedLayoutComponent } from './shared/layouts/shared-layout/shared-layout.component';
import { authenticationGuard } from './core/guards/authentication.guard';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes')
    },
    {
        path: 'main',
        component: SharedLayoutComponent,
        children: [
            {
                path: 'home',
                loadComponent: () => import('./shared/pages/home-page/home-page.component')
            },
            {
                path: 'shop',
                loadComponent: () => import('./shop/pages/shop-page/shop-page.component')
            },
            {
                path: 'shop/checkout/:id',
                loadComponent: () => import('./shop/pages/checkout-page/checkout-page.component')
            },
            {
                path: 'orders',
                loadComponent: () => import('./shop/pages/orders-page/orders-page.component')
            },
            {
                path: '**',
                redirectTo: 'shop'
            }
        ],
        canMatch: [
            authenticationGuard
        ]
    },
    {
        path: '**',
        redirectTo: 'main'
    }
];
